import React from 'react';
import './HistoryComponent.css';
import { Link } from 'react-router-dom';
import visionIcon from '../images/vision.png'; // Replace with your image path
import missionIcon from '../images/mission.png'; // Replace with your image path
import { useLanguage } from '../context/LanguageContext';

const HistoryComponent = () => {
  const { language } = useLanguage();

  return (
      <div className="history-container">
       
        <div className="history-content">
           <h2 className="text-center text-primary">{language === 'ml' ? 'ഞങ്ങളെക്കുറിച്ച്' : 'Who we are'}</h2>
          <p className="history-paragraph fw-normal fst-italic text-justify text-secondary">
            {language === 'ml' ? (
              <>
                 1996-ൽ മഞ്ചേരിയിൽ 'ക്യാൻസർ പെയിൻ & പാലിയേറ്റീവ് കെയർ അസോസിയേഷൻ' (CAPCA) എന്ന പേരിൽ സ്ഥാപിതമായ ഞങ്ങളുടെ പ്രസ്ഥാനം, ഒരു ക്ലിനിക്കിൽ നിന്ന് തുടങ്ങി മലപ്പുറം ജില്ലയിലുടനീളം ജനകീയ പങ്കാളിത്തത്തോടെയുള്ള പാലിയേറ്റീവ് കെയർ നെറ്റ്‌വർക്കായി വളർന്ന്, ഈ മേഖലയിലെ പാലിയേറ്റീവ് പരിചരണത്തിന് തുടക്കമിട്ടു. ഇന്ന്, 'സെന്റർ ഫോർ ഡെവലപ്‌മെന്റ് ഓഫ് പാലിയേറ്റീവ് കെയർ' (CDPC) വഴി മഞ്ചേരി നഗരസഭയിലുടനീളം സന്നദ്ധപ്രവർത്തകധിഷ്ഠിത സേവനങ്ങൾ ഏകോപിപ്പിക്കുന്നതോടൊപ്പം, പരിശീലന പരിപാടികളിലൂടെയും ഗവേഷണങ്ങളിലൂടെയും പാലിയേറ്റീവ് മെഡിസിൻ മേഖലയെ ഞങ്ങൾ മുന്നോട്ട് നയിക്കുന്നു. സുസ്ഥിരമായ സാമൂഹിക പങ്കാളിത്തത്തിലൂടെ വ്യക്തിത്വം നിലനിർത്തിക്കൊണ്ടുള്ള കരുണാർദ്രമായ പരിചരണം നൽകുക എന്ന സ്ഥാപക ലക്ഷ്യം ഞങ്ങൾ ഇപ്പോഴും നിലനിർത്തുന്നു.
                <Link to="/historypage" className="text-info">More..</Link>
              </>
            ) : (
              <>
                Established in 1996 as the Cancer Pain & Palliative Care Association (CAPCA) in Manjeri, our organization pioneered
                palliative care in Malappuram district, growing from a single clinic to a decentralized network of community-driven
                units across the region. Today, through our Centre for Development of Palliative Care (CDPC), we coordinate volunteer
                based services across Manjeri Municipality while advancing palliative medicine through training programs and research,
                maintaining our founding mission to deliver dignified, compassionate care through sustainable community
                partnerships. <Link to="/historypage" className="text-info">More..</Link>
              </>
            )}
          </p>

          

          <div data-aos="zoom-in" data-aos-duration="800" className="vision-mission-container">
            <div className="vision-mission-card">
              <div className="card-header">
                <img src={visionIcon} alt="Vision" className="card-icon" />
                <h3 className="vision-mission-title text-danger">Vision</h3>
              </div>
              <p className="vision-mission-text">
                {language === "en" ? (
                  `To ensure community-based palliative care is recognized as a universal right and responsibility, delivering dignified, high-quality care through education, research, and ethical coordination, free from exploitation for personal, organizational, political, or religious gain.`
                ) : (
                  `വ്യക്തിപരമോ സംഘടനാപരമോ രാഷ്ട്രീയമോ മതപരമോ ആയ നേട്ടങ്ങൾക്കായി ചൂഷണം ചെയ്യപ്പെടാതെ; വിദ്യാഭ്യാസം, ഗവേഷണം, ധാർമ്മികമായ ഏകോപനം എന്നിവയിലൂടെ അന്തസ്സുറ്റതും മികച്ച ഗുണനിലവാരമുള്ളതുമായ പരിചരണം ഉറപ്പാക്കിക്കൊണ്ട്, ജനകീയ പാലിയേറ്റീവ് പരിചരണം ഏവരുടെയും സാർവത്രിക അവകാശവും ഉത്തരവാദിത്തവുമായി അംഗീകരിക്കപ്പെടുന്നുവെന്ന് ഉറപ്പുവരുത്തുക.`
                )}
              </p>
            </div>

            <div data-aos="zoom-in" data-aos-duration="800" data-aos-delay="500" className="vision-mission-card">
              <div className="card-header">
                <img src={missionIcon} alt="Mission" className="card-icon" />
                <h3 className="vision-mission-title text-danger">Mission</h3>
              </div>
              <p className="vision-mission-text">
                {language === "en" ? (
                  `To establish community-based palliative care as a fundamental right and responsibility by providing dignified, high-quality care through coordinated networks, innovative training, impactful research, and public awareness. We uphold transparency, ethics, and human dignity, fostering a compassionate, inclusive care ecosystem free from exploitation.`
                ) : (
                  `ഏകോപിതമായ നെറ്റ്‌വർക്കുകൾ, നൂതനമായ പരിശീലനങ്ങൾ, ഫലപ്രദമായ ഗവേഷണങ്ങൾ, പൊതുജന ബോധവൽക്കരണം എന്നിവയിലൂടെ അന്തസ്സുറ്റതും മികച്ച ഗുണനിലവാരമുള്ളതുമായ പരിചരണം നൽകിക്കൊണ്ട്, ജനകീയ പാലിയേറ്റീവ് പരിചരണത്തെ ഒരു മൗലികാവകാശമായും ഉത്തരവാദിത്തമായും സ്ഥാപിച്ചെടുക്കുക. ചൂഷണങ്ങളില്ലാത്ത, കരുണാർദ്രവും എല്ലാവരെയും ഉൾക്കൊള്ളുന്നതുമായ ഒരു പരിചരണ അന്തരീക്ഷം വളർത്തിയെടുക്കുന്നതിന് സുതാര്യത, ധാർമ്മികത, മാനുഷിക മൂല്യങ്ങൾ എന്നിവ ഞങ്ങൾ ഉയർത്തിപ്പിടിക്കുന്നു.`
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
   
  );
};

export default HistoryComponent;